import React from 'react'
import * as UI from 'ui'
import { useValue, ValueToCollection } from '@morningtrain/react-resources'
import { Table } from 'widgets/crud'
import { Translation, Translator } from '@morningtrain/react-translations'
import * as Columns from 'support/columns'
import { ChecklistName } from 'support/displays/ChecklistName'
import OnClickTableRow from 'widgets/crud/OnClickTableRow'
import EmployeeOnboardingInfo from './EmployeeOnboardingInfo'
import OnboardingChecklistActivity from 'support/displays/OnboardingChecklistActivity'
import OnboardingChecklistProgress from 'support/displays/OnboardingChecklistProgress'
import DeleteModelOnClick from 'support/actions/generic/DeleteModelOnClick'
import { Link, useRouter } from '@morningtrain/react-navigation'

export default function OnboardingListView ({ displayChecklists = true , user = null}) {
  const router = useRouter()

  const editOnboarding = (model, id) => {
    router.navigate('app.onboarding.checklist', { onboarding_checklist: id })
  }

  const userId = user === null ? useValue('user.id') : user

  return (
    <UI.Card tight className='p-2 px-6'>
      <Link route='app.onboarding.employee' parameters={{ user: userId }}>
        <EmployeeOnboardingInfo />
      </Link>
      {displayChecklists === false
        ? null
        : (
          <Translator namespace='checklists.columns'>
            <ValueToCollection name='collection'>
              <Table row={<OnClickTableRow callback={editOnboarding} />}>
                <Columns.Text
                  name='list' label={<Translation name='list' />}
                  display={<ChecklistName />}
                />
                <Columns.Text
                  name='activity' label={<Translation name='activity' />}
                  display={<OnboardingChecklistActivity />}
                />
                <Columns.Text
                  name='progress' label={<Translation name='progress' />}
                  display={<OnboardingChecklistProgress progressName='completed_percentage' />}
                />
                <Columns.Column>
                  <UI.ButtonWrap className='my-0'>
                    <DeleteModelOnClick>
                      <UI.DeleteButton />
                    </DeleteModelOnClick>
                  </UI.ButtonWrap>
                </Columns.Column>
              </Table>
            </ValueToCollection>
          </Translator>
          )}
    </UI.Card>
  )
}
